import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

import {DialogComponent, DialogConfigInterface} from '../../../../shared/components/dialog';

import {EditTradingAccountAddUserForm} from '../../forms';

@Component({
    selector: 'app-trading-account-add-user',
    templateUrl: './trading-account-add-user.component.html',
    styleUrls: ['./trading-account-add-user.component.scss']
})
export class TradingAccountAddUserComponent extends DialogComponent<TradingAccountAddUserComponent> implements OnInit {
    public editAccountAddUserForm: EditTradingAccountAddUserForm;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: {
            config: DialogConfigInterface
        },
        public dialogRef: MatDialogRef<TradingAccountAddUserComponent>
    ) {
        super(dialogRef);
    }

    ngOnInit() {
        this.editAccountAddUserForm = new EditTradingAccountAddUserForm();
        this.editAccountAddUserForm.initForm();
    }
}
